import { render, staticRenderFns } from "./EditarFuncionariosV2.vue?vue&type=template&id=1593ecc4"
import script from "./EditarFuncionariosV2.vue?vue&type=script&lang=js"
export * from "./EditarFuncionariosV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports